import { render, staticRenderFns } from "./field-detail.vue?vue&type=template&id=cb9eb540&scoped=true&"
import script from "./field-detail.vue?vue&type=script&lang=js&"
export * from "./field-detail.vue?vue&type=script&lang=js&"
import style0 from "./field-detail.vue?vue&type=style&index=0&id=cb9eb540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9eb540",
  null
  
)

export default component.exports